//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ApiError, DepartmentResponse, TeamsState, updateTeamsPayload } from './AppSkillRatingTypes';
import {  fetchApplicationDetailsData } from '../../services/applicationService';
import { fetchAppSkillData, updateAppSKillData } from '../../services/appSkillRatingService';




// fetchApplicationDetailsData
export const fetchAppSkillRatingByDetails = createAsyncThunk<DepartmentResponse, { baseId: number; appId: number; appScoreId: number }, { rejectValue: string }>(
  'fetchAppSkillRatingByDetails/fetch',
  async ({ baseId, appId, appScoreId }, { rejectWithValue }) => {
    try {
      const response = await fetchAppSkillData(baseId, appId, appScoreId);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch job application');
    }
  }
);

export const updateAppSkillRating = createAsyncThunk<
  DepartmentResponse,
  {baseId: number; id: number; data: updateTeamsPayload },
  { rejectValue: string }
>(
  'updateAppSkillRating/update',
  async ({  baseId,id, data }, { rejectWithValue }) => {
    try {
      const response = await updateAppSKillData(baseId, id, data);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to update app skill data');
    }
  }
);


// Initial state
const initialState: TeamsState = {

  fetchAppSkillRatingStauts: 'idle',
  fetchAppSkillRatingError: null,
  fetchAppSkillRatingData: null,
  updateAppSkillRatingStauts: 'idle',
  updateAppSkillRatingError: null,
  updateAppSkillRatingData: null

};

const AppSkillRatingSlice = createSlice({
  name: 'AppSkillRatingData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppSkillRatingByDetails.pending, (state) => {
        state.fetchAppSkillRatingStauts = 'loading';
        state.fetchAppSkillRatingError = null;
      })
      .addCase(fetchAppSkillRatingByDetails.fulfilled, (state, action) => {
        state.fetchAppSkillRatingStauts = 'succeeded';
        state.fetchAppSkillRatingData = action.payload;
        state.fetchAppSkillRatingError = null;
      })
      .addCase(fetchAppSkillRatingByDetails.rejected, (state, action) => {
        state.fetchAppSkillRatingStauts = 'failed';
        state.fetchAppSkillRatingError = action.payload || 'Failed to fetch job application';
      })
      .addCase(updateAppSkillRating.pending, (state) => {
        state.updateAppSkillRatingStauts = 'loading';
        state.updateAppSkillRatingError = null;
      })
      .addCase(updateAppSkillRating.fulfilled, (state, action) => {
        state.updateAppSkillRatingStauts = 'succeeded';
        state.updateAppSkillRatingData = action.payload;
        state.updateAppSkillRatingError = null;
      })
      .addCase(updateAppSkillRating.rejected, (state, action) => {
        state.updateAppSkillRatingStauts = 'failed';
        state.updateAppSkillRatingError = action.payload || 'Failed to update app skill data';
      });
  },
});

export default AppSkillRatingSlice.reducer;
